import { useQuery } from '@tanstack/react-query';
import { currentUserApi } from '../apis';
import { InternalApiCurrentUserInfo } from '../api-internal';

const emptyArray: Array<string> = [] as const;

export const useMe = (): UseMeValuesInState => {
  const { data: me, isLoading } = useQuery({
    refetchInterval: 10 * 60_000,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    queryKey: ['me'],
    queryFn: () => currentUserApi.loadCurrentUser(),
  });

  return {
    ...me,
    isLoading: isLoading,
    isGlobalAdmin: me?.roles.some((role) => ['ADMIN', 'GLOBAL_ENGINEER'].includes(role)) ?? false,
    isCustomerAdmin: me?.roles.includes('CUSTOMER_ADMIN') ?? false,
    permissions: me?.permissions ?? emptyArray,
    features: me?.currentOrganisation?.features ?? emptyArray,
    availableOrganisations: me?.availableOrganisations ?? [],
  } as UseMeValuesInState;
};

type LoadedUseMeValues = InternalApiCurrentUserInfo & {
  isLoading: false;
  isGlobalAdmin: boolean;
  isCustomerAdmin: boolean;
  permissions: string[];
  features: string[];
  availableOrganisations: Array<{ id: number; name: string }>;
};

type UnloadedUseMeValues = Partial<InternalApiCurrentUserInfo> & {
  isLoading: true;
  isGlobalAdmin: boolean;
  isCustomerAdmin: boolean;
  permissions: string[];
  features: string[];
  availableOrganisations: Array<{ id: number; name: string }>;
};

export type UseMeValuesInState = LoadedUseMeValues | UnloadedUseMeValues;
